var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodeWrite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 6C3.5 4.34315 4.84315 3 6.5 3H18.5C20.1569 3 21.5 4.34315 21.5 6V18C21.5 19.6569 20.1569 21 18.5 21H6.5C4.84315 21 3.5 19.6569 3.5 18V6ZM6.5 5C5.94772 5 5.5 5.44772 5.5 6V18C5.5 18.5523 5.94772 19 6.5 19H18.5C19.0523 19 19.5 18.5523 19.5 18V6C19.5 5.44772 19.0523 5 18.5 5H6.5ZM7.79289 9.29289C8.18342 8.90237 8.81658 8.90237 9.20711 9.29289L11.2071 11.2929C11.5976 11.6834 11.5976 12.3166 11.2071 12.7071L9.20711 14.7071C8.81658 15.0976 8.18342 15.0976 7.79289 14.7071C7.40237 14.3166 7.40237 13.6834 7.79289 13.2929L9.08579 12L7.79289 10.7071C7.40237 10.3166 7.40237 9.68342 7.79289 9.29289ZM12.5 14C12.5 13.4477 12.9477 13 13.5 13H16.5C17.0523 13 17.5 13.4477 17.5 14C17.5 14.5523 17.0523 15 16.5 15H13.5C12.9477 15 12.5 14.5523 12.5 14Z",
    fill: "url(#paint0_linear_3914_22731)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3914_22731",
    x1: 12.5,
    y1: 3,
    x2: 12.5,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C82F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeWrite);
export default __webpack_public_path__ + "static/media/CodeWrite.92a956992c268a04fa6ea88d43ea7ff8.svg";
export { ForwardRef as ReactComponent };